import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { findByB2BCustomQuotation } from "./services/b2bQuotation.services";
import { LoadingPanel } from "../../components/layout/Loading";
import IconComponent from "../../components/common/IconComponent";
import {
  FaArrowLeft, FaPencilAlt, FaShareAlt, FaExternalLinkAlt, FaPrint
} from "react-icons/fa";
import { Button } from "@progress/kendo-react-buttons";
import B2BQuotationDocument from "./components/B2BQuotationDocument";
import "./b2bView.scss";

const ViewB2BQuotation: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setLoading(true);
        const res = await dispatch(findByB2BCustomQuotation(Number(id)));
        if (res.meta.requestStatus === "fulfilled") {
          setData(res.payload);
        }
        setLoading(false);
      }
    };
    fetchData();
  }, [id, dispatch]);

  if (loading) return <LoadingPanel />;
  if (!data) return <div className="p-5 text-center">Quotation not found.</div>;

  const handleEdit = () => {
    navigate("/b2bquotation/edit", { state: { QuotationID: data.ID } });
  };

  const openPrintView = () => {
    window.open(`/b2bquotation/view/${data.ID}`, "_blank");
  };

  return (
    <div className="b2b-view-container">
      {/* ── Action Buttons (No Print) ────────────────────────────────────────── */}
      <div className="no-print">
        <Button fillMode="flat" onClick={() => navigate("/b2bquotation")} className="p-0 me-auto">
          <IconComponent icon={FaArrowLeft} /> Back
        </Button>
        <Button themeColor="primary" fillMode="outline" onClick={openPrintView}>
          <IconComponent icon={FaExternalLinkAlt} className="me-2" /> View Full Quote
        </Button>
        <Button themeColor="primary" fillMode="outline" onClick={() => window.print()}>
          <IconComponent icon={FaPrint} className="me-2" /> Print
        </Button>
        <Button themeColor="primary" onClick={handleEdit}>
          <IconComponent icon={FaPencilAlt} className="me-2" /> Edit
        </Button>
        <Button fillMode="outline" themeColor="primary">
          <IconComponent icon={FaShareAlt} className="me-2" /> Share
        </Button>
      </div>

      <B2BQuotationDocument data={data} />
    </div>
  );
};

export default ViewB2BQuotation;
